import { ConcreteEncodable } from "./ConcreteEncodable";

import { CurrencyPairGroupMemberImplEncoder } from "../../encoder/CurrencyPairGroupMemberImplEncoder";

import * as CubiqTS from "../../index";
import { CurrencyPairGroupMember } from "../CurrencyPairGroupMember";

export class CurrencyPairGroupMemberImpl
  extends ConcreteEncodable
  implements CurrencyPairGroupMember
{
  public static enType: string = "com.bcdfx.model.CurrencyPairGroupMemberImpl";

  /*FID=1*/
  public currencypairGroupId: CubiqTS.Long | null = null;
  /*FID=2*/
  public baseCurrencyCd: string;
  /*FID=3*/
  public nonBaseCurrencyCd: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CurrencyPairGroupMemberImplEncoder.Instance;
    this.setEncodableType(CurrencyPairGroupMemberImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CurrencyPairGroupMemberImpl[" +
      "currencypairGroupId=" +
      this.currencypairGroupId +
      "baseCurrencyCd=" +
      this.baseCurrencyCd +
      "nonBaseCurrencyCd=" +
      this.nonBaseCurrencyCd +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
